import { useEffect, useRef, useState } from "react";
import moment from "moment";
export const MessageTimeStamp = ({ time, isUserMsg, isMaximized }) => {
  const timestampRef = useRef(null);
  const [, forceUpdate] = useState();

  useEffect(() => {
    const intervalId = setInterval(() => {
      forceUpdate({});
    }, 50000);

    return () => clearInterval(intervalId);
  }, [time]);

  const duration = moment.duration(moment(new Date()).diff(moment(time)));
  const timeAgo = duration._data.minutes;

  return (
    <p
      ref={timestampRef}
      data-timestamp={time}
      className={`hayley-my-0 hayley-pl-3 hayley-text-xs ${isUserMsg && !isMaximized ? "hayley-pr-3 hayley-text-end" : ""} `}
    >
      {timeAgo >= 1 ? moment(time).format("hh:mm a") : "Just now"}
    </p>
  );
};
